import SVG from "react-inlinesvg";
import styled from "styled-components";

const Wrapper = styled.div`
    background-color: white;
    width: 100%;
    height: auto;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  
    & svg {
      display: flex;
      justify-content: center;
      width: 100%;
      height: auto;
    }
`;
const SVGContainer = ({src, width, height, mode}) => {
  return (
     <Wrapper>
        <SVG
            id={`hjt-svg${mode ? '-modal' : ''}`}
            src={src}
            width={width}
            height={height}
            preserveAspectRatio="none"
        />
     </Wrapper>
  );

}

export default SVGContainer;